import { fetchPostalCodeInfo } from '@widget/api/fetchPostalCodeInfo';
import { getOriginalReferral } from '@widget/core';

export async function prepareLeadData(
  rawFormData: Record<string, unknown>,
  valuation: string | null,
) {
  const { zipCode, ...formData } = rawFormData;
  const { country } = await fetchPostalCodeInfo(zipCode as string);
  const referrerSource = getOriginalReferral();

  const leadBeforeSubmit = {
    ...formData,
    contactForm: formData.contactForm,
    ...(valuation && { shortValuationPricePredict: valuation }),
    zipCode,
    //@todo can we get country code from market ?
    countryCode: country?.toUpperCase(),
    referrerSource,
    // below fields added from URL query params for renderWhen logic only. Should not be sent to the backend.
    tp_channel: undefined,
    hasGetambassadorShortCode: undefined,
  };

  return {
    ...leadBeforeSubmit,
  };
}
